module.exports = __webpack_public_path__ + "img/bread.d3ca998c.svg";